// extracted by mini-css-extract-plugin
module.exports = {"noGames":"_e908c04","oops":"_64bb1fa","message":"_41f6d2f"};